export enum ShareType {
  ClassDetails = 'class-details',
  InviteDetails = 'invite-details',
  TagDetails = 'tag-details',
  GenericWorkoutDetails = 'generic-workout-details',
  DetailedWorkoutDetails = 'detailed-workout-details',
  ScheduleEventDetails = 'schedule-event-details',
}

export enum ShareUrl {
  Classes = '/classes',
  Tags = '/tags',
  Schedule = '/scheduled',
  ShareWorkouts = '/share/workouts',
  Invite = '/invite',
  Members = '/members',
  ProfileWorkouts = '/profile/workouts',
}

type ClassDetailsProps = { classId: string | undefined };
type TagDetailsProps = { tagName: string | undefined };
type GenericWorkoutDetailsProps = {
  workoutId: string;
};
type DetailedWorkoutDetailsProps = {
  shareWorkoutId: string;
};
type InviteDetailsProps = {
  inviteId: string;
};
type ScheduleEventDetailsProps = {
  classId: string;
  start: string;
  type: string;
  queryParams: Record<string, string>;
};

export type ShareProps = {
  [ShareType.ClassDetails]: ClassDetailsProps;
  [ShareType.InviteDetails]: InviteDetailsProps;
  [ShareType.TagDetails]: TagDetailsProps;
  [ShareType.GenericWorkoutDetails]: GenericWorkoutDetailsProps;
  [ShareType.DetailedWorkoutDetails]: DetailedWorkoutDetailsProps;
  [ShareType.ScheduleEventDetails]: ScheduleEventDetailsProps;
};
